export const APP_STORE_URL = 'https://apps.apple.com/app/listing-aigent/id6789615649';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.listingaigent.app';
export const APP_SCHEME_AUTH = 'com.listingaigent.app://auth';

export function detectPlatform() {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
  return 'desktop';
}

export function storeUrlFor(platform) {
  return platform === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
}
